import { useState } from "react";
import { Link, useNavigate, useLocation, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import BrandMark from "@/components/BrandMark";

export default function Login() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) {
    const dest = loc.state?.from?.pathname || "/app/dashboard";
    return <Navigate to={dest} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      nav("/app/dashboard");
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };

  const fillDemo = (kind) => {
    if (kind === "player") { setEmail("player@topofthelot.com"); setPassword("Player123!"); }
    if (kind === "admin")  { setEmail("admin@topofthelot.com");  setPassword("Admin123!"); }
    if (kind === "super")  { setEmail("super@topofthelot.com");  setPassword("SuperAdmin123!"); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#071426] px-4">
      <div className="w-full max-w-md fade-up">
        <div className="flex justify-center mb-8" data-testid="login-brand">
          <BrandMark />
        </div>
        <div className="bg-[#0D2038] border border-[#1F3A5C] rounded-2xl p-7">
          <h1 className="font-heading text-2xl font-bold mb-1">Welcome back</h1>
          <p className="text-sm text-[#AAB7C7] mb-6">Sign in to your account</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-medium uppercase tracking-wider text-[#AAB7C7]">Email</label>
              <input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                data-testid="login-email-input"
                className="mt-1 w-full bg-[#071426] border border-[#1F3A5C] focus:border-[#C7F500] focus:outline-none rounded-lg px-3 py-2.5 text-white"
              />
            </div>
            <div>
              <label className="text-xs font-medium uppercase tracking-wider text-[#AAB7C7]">Password</label>
              <input
                type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                data-testid="login-password-input"
                className="mt-1 w-full bg-[#071426] border border-[#1F3A5C] focus:border-[#C7F500] focus:outline-none rounded-lg px-3 py-2.5 text-white"
              />
            </div>
            {err && <div className="text-sm text-red-400" data-testid="login-error">{err}</div>}
            <button
              type="submit" disabled={busy}
              data-testid="login-submit-btn"
              className="w-full py-3 rounded-lg bg-[#C7F500] hover:bg-[#D9FF27] disabled:opacity-60 font-semibold  text-[#071426] transition-colors"
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <div className="mt-5 text-xs text-[#AAB7C7] space-y-2">
            <div className="flex items-center justify-between">
              <span>Demo accounts:</span>
              <Link to="/forgot-password" className="text-[#C7F500] hover:underline" data-testid="login-forgot-link">Forgot password?</Link>
            </div>
            <div className="flex flex-wrap gap-2">
              <button type="button" onClick={() => fillDemo("player")} data-testid="demo-player-btn" className="px-3 py-1.5 rounded-md bg-[#132A45] hover:bg-[#1B4276]">Player</button>
              <button type="button" onClick={() => fillDemo("admin")} data-testid="demo-admin-btn" className="px-3 py-1.5 rounded-md bg-[#132A45] hover:bg-[#1B4276]">Admin</button>
              <button type="button" onClick={() => fillDemo("super")} data-testid="demo-super-btn" className="px-3 py-1.5 rounded-md bg-[#132A45] hover:bg-[#1B4276]">Super Admin</button>
            </div>
          </div>
          <div className="mt-6 text-sm text-center text-[#AAB7C7]">
            New to Top of the Lot?{" "}
            <Link to="/register" className="text-[#C7F500] hover:underline" data-testid="login-register-link">Create an account</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
